export const UPLOAD_RIDE_STATES = {
    INITIALIZING: 'INITIALIZING',
    UPLOADING_ATRACTIONS_IMAGE: 'UPLOADING_ATRACTIONS_IMAGE',
    ADDING_ATRACTIONS_FROM_IMAGES: 'ADDING_ATRACTIONS_FROM_IMAGES',
    UPLOADING_ACCOMMODATIONS_IMAGE: 'UPLOADING_ACCOMMODATIONS_IMAGE',
    ADDING_ACCOMMODATIONS_FROM_IMAGES: 'ADDING_ACCOMMODATIONS_FROM_IMAGES',
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR',
  };